// extracted by mini-css-extract-plugin
module.exports = {"realRadio":"src-hellospa-foundation-control-radio-radio__realRadio--oKlAK","svgLabel":"src-hellospa-foundation-control-radio-radio__svgLabel--3KPJ9"};